import { useData } from "./useData";
import { Content, SubCategory } from "@robe/core";

/**
 * useSubCategories returns first fetched set of categories fetched in the categories field.
 */
export const useSubCategories = <TContent extends Content = never>() => {
  const { subCategories } = useData<Content, Content[], Content[], [SubCategory<TContent>]>();

  return subCategories;
};
